import { render, staticRenderFns } from "./EditorGalerias.vue?vue&type=template&id=b732c38c"
import script from "./EditorGalerias.vue?vue&type=script&lang=js"
export * from "./EditorGalerias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports